import { Action } from 'redux';
import { Action as ActionHistory } from 'history';
import { IHref } from 'components/Shared/server';

export const HISTORY_UPDATE = '@@HISTORY/UPDATE_HISTORY';
export const HISTORY_LOCATION_CHANGED = '@@HISTORY/LOCATION_CHANGED';

export const HISTORY_METHOD_PUSHSTATE = 'push';
export const HISTORY_METHOD_REPLACESTATE = 'replace';
export const HISTORY_METHOD_GO = 'go';
export const HISTORY_METHOD_GO_FORWARD = 'goForward';
export const HISTORY_METHOD_GO_BACK = 'goBack';

export interface PayloadParams {
  url: IHref;
  state?: Record<string, unknown> | string | number;
  scrollPosition?: [number, number];
  screenHeight?: number;
}

export type GoParams = number;

export type NavigationParams = PayloadParams | GoParams;
export interface HistoryAction extends Action {
  method: string;
  payload: NavigationParams;
}

const updateHistory = (method: string) => (params: PayloadParams | GoParams) => ({
  type: HISTORY_UPDATE,
  method,
  payload: params
});

export const historyPushState = updateHistory(HISTORY_METHOD_PUSHSTATE) as (
  args: PayloadParams
) => HistoryAction;
export const historyReplaceState = updateHistory(HISTORY_METHOD_REPLACESTATE) as (
  args: PayloadParams
) => HistoryAction;
export const historyGo = updateHistory(HISTORY_METHOD_GO) as (go: GoParams) => HistoryAction;
export const historyForward = updateHistory(HISTORY_METHOD_GO_FORWARD) as () => HistoryAction;
export const historyBack = updateHistory(HISTORY_METHOD_GO_BACK) as () => HistoryAction;

export interface ChangeLocationParams {
  url: IHref;
  action?: ActionHistory;
}
export type HistoryChangeAction = Action & ChangeLocationParams;
export const historyChangeLocation = (params: ChangeLocationParams): HistoryChangeAction => ({
  type: HISTORY_LOCATION_CHANGED,
  ...params
});
